"use client";

import { useGlobal } from "@/features/global/GlobalContext";
import { clsx } from "@frend-digital/ui";
import styles from "../ProductCard.module.css";

interface ProductCardPriceProps {
	price: string;
	showAsOnSale?: boolean;
	priceBeforeDiscount?: string;
	campaignTagColor?: string | number;
}

export const ProductCardPrice = ({
	price,
	showAsOnSale,
	priceBeforeDiscount,
	campaignTagColor,
}: ProductCardPriceProps) => {
	const { data: globalData } = useGlobal();
	const colorEntry = campaignTagColor ? globalData.colorMap[campaignTagColor] : undefined;

	return (
		<dd className={clsx(styles.price, "product-card-price")}>
			{colorEntry && showAsOnSale ? (
				<span
					className={styles.campaignPrice}
					style={
						{
							"--tag-color": colorEntry.color,
							"--tag-foreground": colorEntry.foreground,
						} as React.CSSProperties
					}
				>
					{price}
				</span>
			) : (
				price
			)}
			{showAsOnSale && (
				<span className={styles.discountedPrice}> {priceBeforeDiscount}</span>
			)}
		</dd>
	);
};
